import { registerComponent } from '@gig/magic-common';
import SweepstakesRedeemComponent from './sweepstakes-redeem.vue.js';

var SweepstakesRedeem = registerComponent(SweepstakesRedeemComponent);

export { SweepstakesRedeem };
